import React, { useState, useEffect, forwardRef } from "react";
import classes from "../styles/Gallery.module.css";
import GalleryElementHeader from "./GalleryElementHeader/GalleryElementHeader";
import GalleryElMedia from "./GalleryElMedia/GalleryElMedia";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { baseURL } from "../../../assets/constants/baseUrl";
import VideoPlayer from "../../../assets/components/VideoPlayer";
import { FaDownload } from "react-icons/fa";
import Loading from "../../../assets/containers/loadingDialog";
const imageExtensions = ["jpg", "jpeg", "png", "gif"];

const GalleryElement = forwardRef(({ category, date, media }, ref) => {
  const [allMedia, setAllMedia] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [fileType, setFileType] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setAllMedia(media);
  }, [media]);

  const handleClick = (type, index) => {
    setIsOpen(true);
    setFileType(type);
    setCurrentIndex(index);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  const moveNext = () => {
    const nextIndex = (currentIndex + 1) % allMedia.length;
    const extention = allMedia[nextIndex].name.split(".").pop().toLowerCase();
    if (imageExtensions.includes(extention)) {
      setFileType("img");
    } else {
      setFileType("video");
    }
    setCurrentIndex((currentIndex + 1) % allMedia.length);
  };

  const movePrev = () => {
    const prevIndex = (currentIndex + allMedia.length - 1) % allMedia.length;
    const extention = allMedia[prevIndex].name.split(".").pop().toLowerCase();
    if (imageExtensions.includes(extention)) {
      setFileType("img");
    } else {
      setFileType("video");
    }
    setCurrentIndex((currentIndex + allMedia.length - 1) % allMedia.length);
  };

  const currentMedia = allMedia[currentIndex];

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${baseURL}file/get/${currentMedia.name}`;
    link.setAttribute("download", currentMedia.name.split("/").pop());
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className={classes.galleryElementContainer} ref={ref}>
        <GalleryElementHeader category={category} date={date} />
        <div className={classes.galleryMediaContainer}>
          <div className="row px-0 mx-0">
            {allMedia.map((el, index) => (
              <div className="col-4 px-0" key={index}>
                <GalleryElMedia
                  media={el}
                  handleSelect={(type) => handleClick(type, index)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {isOpen && fileType === "img" && (
        <Lightbox
          mainSrc={`${baseURL}file/get/${currentMedia.name}`}
          mainSrcThumbnail={`${baseURL}file/get/512-${currentMedia.name}?thumbnail=true`}
          nextSrc={allMedia[(currentIndex + 1) % allMedia.length].name}
          prevSrc={
            allMedia[(currentIndex + allMedia.length - 1) % allMedia.length]
              .name
          }
          loader={<Loading />}
          onCloseRequest={handleClose}
          onMovePrevRequest={movePrev}
          onMoveNextRequest={moveNext}
          toolbarButtons={[
            <FaDownload
              key="download-button"
              color="#aaaaaa"
              onClick={handleDownload}
            />,
          ]}
        />
      )}

      {isOpen && fileType !== "img" && (
        <VideoPlayer
          open={true}
          closeHandler={handleClose}
          videoUrl={`${baseURL}file/get/${currentMedia.name}`}
        />
      )}
    </>
  );
});

export default GalleryElement;
